import { render } from "./DeleteGroupDialog.vue?vue&type=template&id=2ca5d59e"
import script from "./DeleteGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__